import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { SignUpComponent } from './sign-up.component';
export var SignUpComponentNgModule = module(baseModuleId + ".sign-up", [])
    .component('signUp', SignUpComponent);
